import {
	disableNotificationInterceptors,
	type FetchUserMeAuthenticationMethodsParams,
	type PostUserUserUserAuthenticationValidatePayload
} from '@capsicum/common';

import { userApi } from '../api';

export async function fetchUserAuthMethods(query?: FetchUserMeAuthenticationMethodsParams) {
	return (await userApi)
		.fetchUserMeAuthenticationMethods({
			...query
		})
		.then(res => res.data);
}

export async function postUserAuthenticationValidate(payload: PostUserUserUserAuthenticationValidatePayload) {
	return (await userApi).postUserUserUserAuthenticationValidate(payload, {
		customErrorInterceptor: disableNotificationInterceptors
	});
}
